import { userSlice, refreshTokenIntervalSlice, resizeSlice, constantStore, sidebarSlice } from "./reducer";

export const actions = {
    ...userSlice.actions,
    ...refreshTokenIntervalSlice.actions,
    ...resizeSlice.actions,
    ...constantStore.actions,
    ...sidebarSlice.actions
};